'use strict';

export {
	default as HotbarStaticDataProvider
} from './hotbar.static.dataProvider';

export {
	default as HotbarEndpointDataProvider
} from './hotbar.endpoint.dataProvider';
